<template>
    <header class="c-header">
        <app-logo></app-logo>

        <div class="c-header__nav">
            <div class="dropdown" v-if="account.status.loggedIn">
                <a href="#0" class="c-header__nav-link || dropdown-toggle" v-on:click.prevent="toggleDropdown">
                    <div class="c-header__btn-text" v-if="account.user">Welkom<span class="u-hidden-sm-down">, {{ account.user.name }}</span></div>
                    <div class="c-header__btn-text" v-else>Welkom</div>

                    <svg class="dropdown-toggle__svg" xmlns="http://www.w3.org/2000/svg" width="9.971" height="5.986" viewBox="0 0 9.971 5.986">
                        <path d="M1.414 1.415l3.571 3.572 3.572-3.572" fill="none" stroke="#d75158" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </svg>
                </a>

                <ul class="dropdown-menu" v-show="dropdownIsOpen">
                    <router-link class="dropdown__link" to="/admin/locations">Vestigingen</router-link>
                    <router-link class="dropdown__link" to="/admin/subscriptions">Abonnementen</router-link>
                    <router-link class="dropdown__link" to="/admin/storec-mobiel">Storec gebruikers</router-link>
                    <router-link class="dropdown__link" to="/admin/invoices">Facturen</router-link>
                    <router-link class="dropdown__link" to="/admin/account">Mijn gevevens</router-link>
                    <li class="dropdown__divider"></li>
                    <a href="#0" class="dropdown__link" v-on:click.prevent="logoutUser">Uitloggen</a>
                </ul>
            </div>

            <a href="https://addsoft.zendesk.com/hc/nl" class="[ c-btn c-btn--info ] c-header__btn" target="_blank">Support</a>
        </div>
    </header>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import AppLogo from './AppLogo.vue';
    import * as ls from '../../helpers/localStorage';

    export default {
        components: { AppLogo },
        data () {
            return {
                dropdownIsOpen: false,
                menuDropdownIsOpen: false,
            };
        },
        computed: {
            ...mapState({
                account: (state) => state.account,
            }),
        },
        watch: {
            $route () {
                this.dropdownIsOpen = false;
                this.menuDropdownIsOpen = false;
            },
        },
        created () {
            // only get the account when there is a token
            if (ls.get('account:token'))
            {
                this.$store.dispatch('account/user');
            }
        },
        methods: {
            ...mapActions('account', ['logout']),
            toggleDropdown () {
                this.dropdownIsOpen = !this.dropdownIsOpen;
            },
            logoutUser () {
                this.logout();
            },
        },
    };
</script>


<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-header {
        @include set-properties(height);
        align-items: center;
        display: flex;
        background-color: $white;
        box-shadow: 0 rem(5) rem(30) rgba($brand-primary, .1);
        grid-area: header;
        padding: 0 grid(1);
        justify-content: space-between;
        transition: $transition-base;
        z-index: $zindex-fixed;

        @include media-breakpoint-up(sm) {
            padding: 0 grid(2, sm);
        }

        @include media-breakpoint-up(lg) {
            padding: 0 grid(2, lg);
        }

        &__nav {
            align-items: center;
            height: inherit;
            display: flex;

            > * + * {
                margin-left: grid(1);

                @include media-breakpoint-up(sm) {
                    margin-left: grid(1, sm);
                }

                @include media-breakpoint-up(lg) {
                    margin-left: grid(1, lg);
                }
            }

            &-link {
                color: $text-color;
                font-weight: $font-weight-bold;
            }
        }
    }

    .dropdown {
        position: relative;

        &-toggle {
            align-items: center;
            display: flex;

            &__svg {
                margin-left: grid(1 / 2);
            }
        }

        &-menu {
            @include absolute(top 100% right 0);
            @include zero;
            background-color: $white;
            border-radius: grid(1);
            filter: drop-shadow(0 rem(10) rem(30) rgba($brand-primary, .1));
            list-style: none;
            padding: grid(1, lg);
            margin-top: grid(1, lg);
            min-width: rem(240);
            z-index: 100;

            &:before {
                @include square(0);
                border-style: solid;
                content: "";
            }

            &:before {
                @include absolute(top rem(-10) right rem(32));
                border-width: 0 rem(8) rem(10) rem(8);
                border-color: transparent transparent $white transparent;
                z-index: 1;
            }
        }

        &__divider {
            height: rem(1);
            margin: rem(10) 0;
            overflow: hidden;
            background-color: $gray-light;
        }

        &__link {
            color: $brand-primary;
            display: block;
            font-weight: $font-weight-bold;
            transition: $transition-base;

            @include hover {
                color: darken($brand-primary, 10%);
            }

            &.router-link-exact-active {
                text-decoration: underline;
            }

            &.disabled {
                opacity: 0.5;
                pointer-events: none;
            }
        }
    }
</style>
